import ReactDOM from "react-dom";
import swal from "sweetalert";
import RecurringShiftSwitch from "pages/Rostering/WorkerShift/RecurringShiftSwitch";
import React, { useEffect, useState, useCallback } from "react";
import { IoWarningOutline } from "react-icons/io5";

const UpdateRecurringShiftsModal = (props) => {
  const {
    title,
    dangerMode = false,
    setIsConfirm,
    isOpen = false,
    shiftData = null,
    setIsRecurringShift,
    watch,
    setValue,
    control,
    recurringUpdateShiftData,
    refreshCalendar,
    createOrUpdateWorkerShiftRequest,
    watchFormData,
    elevatedZIndex = false,
  } = props;

  const [recurringEffectedShiftCount, setRecurringEffectedShiftCount] = useState(null);
  const [loading, setLoading] = useState(false);

  // SweetAlert renders at z-index 10000 by default, which is below the
  // full-screen advance shift modal (z-[99999]). Bump the overlay/modal above
  // it so the confirmation isn't hidden behind the advance layout.
  const applyElevatedZIndex = () => {
    const bump = (attempt = 0) => {
      const overlays = document.querySelectorAll(".swal-overlay");
      const modals = document.querySelectorAll(".swal-modal");
      if (!overlays.length && !modals.length && attempt < 20) {
        requestAnimationFrame(() => bump(attempt + 1));
        return;
      }
      // Must use !important to override index.css (.swal-overlay { z-index: 10050 !important })
      // so this confirm appears above advance fullscreen modal (z-[99999]).
      overlays.forEach((el) => {
        el.style.setProperty("z-index", "100001", "important");
      });
      modals.forEach((el) => {
        el.style.setProperty("z-index", "100002", "important");
      });
    };
    bump();
  };

  const handleChangeAction = useCallback(() => {
    const container = document.createElement("div");

    ReactDOM.render(
      <div>
        <RecurringShiftSwitch
          control={control}
          watchFormData={watchFormData}
          selectedShift={shiftData}
          setValue={setValue}
          recurringEffectedShiftCount={recurringEffectedShiftCount}
          setRecurringEffectedShiftCount={setRecurringEffectedShiftCount}
          setIsRecurringShift={setIsRecurringShift}
          setLoading={setLoading}
        />
        {recurringEffectedShiftCount !== null &&
          recurringEffectedShiftCount !== undefined && (
            <div className='flex items-center mt-2 bg-yellow-100 border border-yellow-500 text-yellow-700 p-1 rounded'>
              <IoWarningOutline className='text-yellow-500 mr-2 h-6 w-6' />
              <p className='text-sm font-semibold'>
                {recurringEffectedShiftCount > 0
                  ? `The changes will impact ${recurringEffectedShiftCount} additional shifts.`
                  : "There are no other recurring shifts aside from this one."}
              </p>
            </div>
          )}
      </div>,
      container
    );

    swal({
      title: title,
      content: container,
      buttons: ["No, take me back!", "Yes, go ahead!"],
      dangerMode: dangerMode,
    }).then((willUpdate) => {
      setIsConfirm(false);


      if (willUpdate) {
        setLoading(true);
        recurringUpdateShiftData.data.recurring_impact = watchFormData?.recurring_impact;

        createOrUpdateWorkerShiftRequest(recurringUpdateShiftData, () => {
          setLoading(false);
          setIsConfirm(false);

          const payload = { isRefreshCall: true };
          refreshCalendar(payload);

          swal.close();
        });
      }
    });

    if (elevatedZIndex) {
      applyElevatedZIndex();
    }
  }, [
    control,
    dangerMode,
    setIsConfirm,
    setLoading,
    setIsRecurringShift,
    setValue,
    recurringEffectedShiftCount,
    recurringUpdateShiftData,
    refreshCalendar,
    shiftData,
    watchFormData,
    elevatedZIndex,
  ]);

  
  useEffect(() => {
    if (isOpen) {
      handleChangeAction();
    }
  }, [isOpen, handleChangeAction]);

  return null;
};

export default React.memo(UpdateRecurringShiftsModal);
